import { DictionaryOptionsRequest } from '../component/control-panel/dictionary/dictionaryOptionsRequest';
import { Option } from '../component/control/option';
import { post } from './rest';

const options = {
    options: (request: DictionaryOptionsRequest) => post<Option[]>('options', request),
};

export default options;
